import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

const UIString = {
    ucWords: (str) => startCase(toLower(str)),
};

export {
    UIString
};